import React from 'react';
import { FadeIn, Button } from './Shared';
import { ShieldCheck, Download } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 px-4 bg-[#0a0a0a] relative border-t border-neutral-900" data-id="element-106">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-toxic/5 rounded-full blur-[120px] pointer-events-none" data-id="element-107" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-108">
        <FadeIn data-id="element-109">
          <div className="border border-toxic/30 bg-neutral-900/80 backdrop-blur-sm p-8 md:p-12 text-center relative overflow-hidden" data-id="element-110">
            {/* Top accent line */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-toxic" data-id="element-111" />

            <h2 className="text-3xl md:text-5xl font-black uppercase mb-6" data-id="element-112">
              Reclaim your lungs and your bank account
            </h2>
            <p className="text-xl text-neutral-400 mb-12" data-id="element-113">
              For the price of a single disposable.
            </p>

            <div className="bg-[#0a0a0a] border border-neutral-800 p-8 max-w-md mx-auto mb-12" data-id="element-114">
              <div className="text-sm font-bold text-toxic tracking-widest uppercase mb-4" data-id="element-115">
                Complete 21-Day Protocol
              </div>
              <div className="text-2xl font-display font-bold text-white mb-2" data-id="element-116">
                The Vape-to-Zero Blueprint
              </div>
              <div className="flex items-center justify-center gap-3 mt-6" data-id="element-117">
                <span className="text-2xl font-bold text-neutral-600 line-through" data-id="element-118">
                  $19.99
                </span>
                <span className="text-5xl font-black text-white" data-id="element-119">$9.99</span>
                <span className="text-neutral-500 font-bold" data-id="element-120">AUD</span>
              </div>
              <div className="mt-3 inline-block bg-toxic/20 border border-toxic/30 px-3 py-1 text-toxic text-sm font-bold tracking-wider uppercase" data-id="element-121">
                50% OFF — Limited Time
              </div>
            </div>

            <div className="max-w-md mx-auto" data-id="element-122">
              <Button fullWidth className="py-5 text-lg mb-4" onClick={() => {
              if ((window as any).fbq) {
                ;
                (window as any).fbq('track', 'AddToCart', {
                  content_name: 'The Vape-to-Zero Blueprint',
                  content_type: 'product',
                  value: 9.99,
                  currency: 'AUD'
                });
              }
              window.open('https://www.versastorex.com/cart/42204756869200:1', '_blank');
            }} data-id="element-123">
                Get The Blueprint Now
              </Button>
              <div className="flex items-center justify-center gap-6 text-sm text-neutral-500 font-medium" data-id="element-124">
                <span className="flex items-center gap-2" data-id="element-125">
                  <ShieldCheck size={16} className="text-toxic" data-id="element-126" />
                  Secure Checkout
                </span>
                <span className="flex items-center gap-2" data-id="element-127">
                  <Download size={16} className="text-toxic" data-id="element-128" />
                  Instant PDF Download
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}